import * as React from 'react';
import { useSelector } from 'react-redux';

import { currentOpenChatSelector } from '../selectors';
import { TMessage, TOutcomingStatus } from '../types/messages';
import { isReplyableMessage, isSendMessageAvailable } from '../utils/replyMessageAvailability';
import { useIsReplyableChat } from './useIsReplyableChat';
import { useRepliesEnabled } from './useRepliesEnabled';

type TReplyableMessage = TMessage & { status?: TOutcomingStatus };

export const useReplyAvailability = (message?: TReplyableMessage): boolean => {
  const { chatId = '', availableActions } = useSelector(currentOpenChatSelector) ?? {};
  const isRepliesEnabled = useRepliesEnabled();
  const isReplyableChat = useIsReplyableChat(chatId);

  return React.useMemo(
    () =>
      isRepliesEnabled && isReplyableChat && isSendMessageAvailable(availableActions) && isReplyableMessage(message),
    [isReplyableChat, availableActions, message, isRepliesEnabled],
  );
};
